export default __webpack_public_path__ + "static/media/(25).c506791e.jpeg";